import { apiClient, avsoftClient } from "../../shared/api/clients";

export interface UpdateUserRequest {
  userId: string;
  email: string;
  phone: string;
}

/** PUT /profile/update-user — relayé par le backend BI vers Avsoft. */
export const updateUserProfile = (req: UpdateUserRequest) =>
  apiClient.put<unknown>("/profile/update-user", req);

interface UploadPhotoResponse {
  data?: {
    Url?: string;
    url?: string;
    secureUrl?: string;
    secure_url?: string;
  };
}

/** POST {Avsoft}/PieceJointe/upload/photo — retourne l'URL publique de la photo. */
export async function uploadProfilePhoto(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await avsoftClient.post<UploadPhotoResponse>(
    "/PieceJointe/upload/photo",
    formData,
  );
  const d = data?.data;
  return d?.Url || d?.url || d?.secureUrl || d?.secure_url || "";
}
